/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PaykuToken } from './payku-token';

/**
 *
 * @export
 * @interface Payku
 */
export class Payku {
    /**
     *
     * @type {{ [key: string]: PaykuToken; }}
     * @memberof Payku
     */
    tokens: { [key: string]: PaykuToken };
    /**
     *
     * @type {string}
     * @memberof Payku
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Payku
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Payku
     */
    type: string;
    /**
     *
     * @type {boolean}
     * @memberof Payku
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Payku
     */
    autoApprove: boolean;
}
